function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 1.33325C4.31334 1.33325 1.33334 4.31325 1.33334 7.99992C1.33334 11.6866 4.31334 14.6666 8 14.6666C11.6867 14.6666 14.6667 11.6866 14.6667 7.99992C14.6667 4.31325 11.6867 1.33325 8 1.33325ZM10.8667 10.8666C10.6067 11.1266 10.1867 11.1266 9.92667 10.8666L8 8.93992L6.07334 10.8666C5.81334 11.1266 5.39334 11.1266 5.13334 10.8666C4.87334 10.6066 4.87334 10.1866 5.13334 9.92659L7.06 7.99992L5.13334 6.07325C4.87334 5.81325 4.87334 5.39325 5.13334 5.13325C5.39334 4.87325 5.81334 4.87325 6.07334 5.13325L8 7.05992L9.92667 5.13325C10.1867 4.87325 10.6067 4.87325 10.8667 5.13325C11.1267 5.39325 11.1267 5.81325 10.8667 6.07325L8.94 7.99992L10.8667 9.92659C11.12 10.1799 11.12 10.6066 10.8667 10.8666Z",
  fill: "#CA2323"
});

var SvgAcAbsenceTimeline = function SvgAcAbsenceTimeline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcAbsenceTimeline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ac-absence-timeline.2108554a.svg";
export { ForwardRef as ReactComponent };